import { Layout as AntLayout, Grid } from "antd";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "widgets/sidebar/Sidebar";
import { MainHeader } from "widgets/mainHeader/MainHeader";
import layoutStyles from "./layout.module.css";
import useMediaQuery from "shared/hooks/useMediaQuery";
import { useSelector } from "react-redux";
import { getAuthState } from "features/auth/model/authSlice";

export const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);
  const { roles } = useSelector(getAuthState);
  const screens = Grid.useBreakpoint();

  const screensLg = useMediaQuery("(min-width: 992px)");

  const showBackdrop = !screensLg && !sidebarCollapsed;

  const roleAliases = (roles ?? [])
    .map((r) => r.alias?.trim()?.toLowerCase())
    .filter(Boolean);

  return (
    <AntLayout hasSider style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
        roles={roleAliases}
      />

      {showBackdrop && (
        <div
          className={layoutStyles.backdrop}
          onClick={() => setSidebarCollapsed(true)}
        />
      )}

      <AntLayout
        style={{
          marginInlineStart: screensLg ? (sidebarCollapsed ? 0 : 250) : 0,
          transition: "margin-inline-start .2s ease",
          background: "#F7FAF8",
        }}
      >
        <MainHeader
          sidebarCollapsed={sidebarCollapsed}
          setSidebarCollapsed={setSidebarCollapsed}
        />
        <AntLayout.Content
          style={{
            padding: screens.xs ? 12 : 24,
            overflow: "initial",
          }}
        >
          <Outlet />
        </AntLayout.Content>
      </AntLayout>
    </AntLayout>
  );
};
